module.exports = __webpack_public_path__ + "static/media/web-automation-with-python-language.a1c7c37f.md";